// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "assets/js/" + chunkId + ".chunk." + "b44385354a3b552c470e" + ".js";
};